/*!
 * All material copyright ESRI, All Rights Reserved, unless otherwise specified.
 * See https://github.com/Esri/calcite-design-system/blob/dev/LICENSE.md for details.
 * v2.13.2
 */
import { calciteContainerSizeWidthLg, calciteContainerSizeWidthMd, calciteContainerSizeWidthSm, calciteContainerSizeWidthXs, calciteContainerSizeWidthXxs, } from "@esri/calcite-design-tokens/dist/es6/global";
/**
 * A breakpoints lookup object.
 */
export const breakpoints = {
    width: {
        large: cssLengthToNumber(calciteContainerSizeWidthLg.max),
        medium: cssLengthToNumber(calciteContainerSizeWidthMd.max),
        small: cssLengthToNumber(calciteContainerSizeWidthSm.max),
        xsmall: cssLengthToNumber(calciteContainerSizeWidthXs.max),
        xxsmall: cssLengthToNumber(calciteContainerSizeWidthXxs.max),
    },
};
function cssLengthToNumber(length) {
    return parseInt(length);
}
//# sourceMappingURL=responsive.js.map
